import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { PRESENCE_INTERVAL_MS, pingIfWanted } from '../services/presencePinger';

/**
 * Invisible app-level component: while the app is open and the user is signed
 * in, offers a presence ping on start, whenever the app returns to the
 * foreground, and every 10 minutes. `pingIfWanted` decides whether one is
 * actually wanted and due. Mount once, beside TrackingWatcher.
 */
export default function PresenceWatcher() {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;
    void pingIfWanted();
    const timer = setInterval(() => { void pingIfWanted(); }, PRESENCE_INTERVAL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') void pingIfWanted(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [isAuthenticated, isLoading]);

  return null;
}
